<!--
 * @Author: Latte
 * @Date: 2021-09-09 14:20:24
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-09 14:12:46
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\CSDocumentManagement\file\index.vue
-->
<template>
  <div class="app-container">
    <div align="right" style="margin-right:1px;">
      <el-dropdown>
        <span class="el-dropdown-link"><i class="el-icon-s-operation"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="openDrawer('resourceTypeDrawer','产品资料访问权限管理')">资料类型管理</el-dropdown-item>
          <el-dropdown-item @click.native="openDrawer('filterCondition','分类管理')">分类管理</el-dropdown-item><!--          <el-dropdown-item @click.native="openDrawer('resourceType','产品资料访问权限管理')">资料类型管理(旧)</el-dropdown-item>-->
          <el-dropdown-item @click.native="openDrawer('userRecord','用户浏览记录')">用户浏览记录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-drawer
            :visible.sync="drawerEditFileCategory"
            :direction="direction"
            :title="drawerTitle"
            style="overflow: auto;"
            size="50%">
      <UserRecord v-if="activeName === 'userRecord'" />
      <FileCategory v-if="activeName === 'resourceType'" />
      <FilterCondition v-if="activeName === 'filterCondition'" />
      <FileCategoryDrawer v-if="activeName === 'resourceTypeDrawer'"/>
    </el-drawer >
    <FileList :init-file-search-value="initFileSearchValue"/>
  </div>
</template>

<script>
import FileList from "@/components/FileManagement/File/fileList.vue";
import FileCategory from "@/components/FileManagement/File/fileCategory.vue";
import FilterCondition from "@/components/FileManagement/File/category.vue";
import UserRecord from '@/components/FileManagement/User/userRecord';
import FileCategoryDrawer from "@/components/FileManagement/File/fileCategoryDrawer.vue";

export default {
  components: {
    FileList,
    FileCategory,
    FilterCondition,
    UserRecord,
    FileCategoryDrawer
  },
  created() {
    this.initFileSearchValue = this.$route.query.fileSearchValue
  },
  data() {
    return {
      initFileSearchValue: "",
      direction: 'rtl',
      drawerTitle:"",
      drawerEditFileCategory:false,
      browserRecord:false,
      conditionManagement:false,
      activeName: "",
    };
  },
  methods: {
    openDrawer(e,drawerTitle){
      if(e!==''){
        this.activeName=e;
      }
      if(drawerTitle!==''){
        this.drawerTitle=drawerTitle;
      }
      this.drawerEditFileCategory=true;
    },

  },
};
</script>

<style scoped lang="scss">
  .demo-table-expand {
    font-size: 0;
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 100%;
      ::v-deep .el-form-item__label {
        width: 120px;
        color: #99a9bf;
      }
    }
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .el-icon-s-operation {
    font-size: 24px;
  }
</style>
